/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Problem } from '../../models/problem';

export interface LinkShortenerRedirect$Params {

/**
 * The shortened link identifier.
 */
  link: string;
}

export function linkShortenerRedirect(http: HttpClient, rootUrl: string, params: LinkShortenerRedirect$Params, context?: HttpContext): Observable<StrictHttpResponse<Problem>> {
  const rb = new RequestBuilder(rootUrl, linkShortenerRedirect.PATH, 'get');
  if (params) {
    rb.path('link', params.link, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/problem+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Problem>;
    })
  );
}

linkShortenerRedirect.PATH = '/link-shortener/{link}';
